<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">

  <div class="w-full p-2 flex-1">

    <!-- Bouton Retour -->
    <div class="mx-auto max-w-2xl m-4 w-full">
      <button (click)="cancel()" class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">
        Retour
      </button>
    </div>

    <!-- Bouton Select All -->
    <div class="flex flex-col gap-2 mb-4">
      <button (click)="toggleSelectAllItems()"
        class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">
        {{ allItemsSelected ? 'Tout désélectionner' : 'Tout sélectionner' }}
      </button>
    </div>

    <!-- LISTE SCROLLABLE -->
    <div class="overflow-y-auto max-h-[30vh] pr-2">
      <ul class="list-none p-0 my-4">
        <li *ngFor="let item of items" (click)="toggleItem(item, !item.selected)" [ngClass]="[
                'flex items-center justify-between p-2 mb-2 rounded hover:bg-green-200 cursor-pointer transition',
                item.selected ? 'bg-green-100 font-bold' : 'bg-gray-100',
                item.remainingQuantity === 0 ? 'opacity-50' : ''
              ]">

          <!-- Nom + quantité + prix -->
          <span *ngIf="item.remainingQuantity > 0">{{ item.name }} x {{ item.partialQuantity }}</span>
          <span *ngIf="item.remainingQuantity === 0"><s>{{ item.name }}</s></span>

          <span class="ml-2">
            {{ getTotalTtcWithChildrenAndQuantity(item) | number:data.currencyFormat.decimalsString }}
            {{ data.currencyFormat.currencySymbol }}
            <span *ngIf="item.alreadyPaid && item.remainingQuantity === 0"
              class="text-green-500 text-xs ml-2">Payé</span>
          </span>

          <!-- 🔁 Contrôles de quantité -->
          <div *ngIf="item.selected && item.remainingQuantity > 1" class="flex items-center gap-1 mt-2">
            <button mat-mini-fab color="primary" (click)="decreasePartialQuantity(item); $event.stopPropagation()"
              [disabled]="item.partialQuantity <= 1">
              <mat-icon>remove</mat-icon>
            </button>
            <span>{{ item.partialQuantity }}</span>
            <button mat-mini-fab color="primary" (click)="increasePartialQuantity(item); $event.stopPropagation()"
              [disabled]="item.partialQuantity >= item.remainingQuantity">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </li>
      </ul>
    </div>

    <!-- Bouton Valider -->
    <div class="mx-auto max-w-2xl m-4 w-full">
      <button [disabled]="!hasSelectedItems()" (click)="confirmSelection()"
        class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">
        Valider
      </button>
    </div>
  </div>
</app-dialog-wrapper>